// 农历转换工具

const heavenlyStemStr = '甲乙丙丁戊己庚辛壬癸'
const earthlyBranchStr = '子丑寅卯辰巳午未申酉戌亥'
const zodiacStr = '鼠牛虎兔龙蛇马羊猴鸡狗猪'
const lunarMonthStr = '正二三四五六七八九十冬腊'
const numberStr = '一二三四五六七八九十'

// 农历数据表格
const table = []

// 初始化农历数据
function initLunarData() {
  const base64Str = 'hLaCVwUrqpNDSYNlUaqgrUE1pJXQSuak2FJoaSrqlC1QNailtBK26TcElwpLWyWDUoNqJW1ArYJVySXgkuzJYNSg6lVtSC1oFbHJuCS58loZKhqU20oLVQVqSq2BLoSWlkrCpV7SoNlBaqqrUE2gpbNSuClcVKg6VBqpq1QVaglslK4KVwUmPpMGyrrVQVqCW1UroJWhSamk0NJY1ShaoFtTS2glbBJtKS4Ul1ZLBqUG1GraBVsEq6pLwSXBks2pQdSw1lBawKtlk2hJcGSyalQ1KDaUlqoK1PVbAl0JLVyVhUqFpSWqgrVlVqCXQUtspXBSsKk0dKg1UFapJtQS2alcFJwaTL0mDVMFqja1BLbaV0ErQpNbSWGkoapLtUC1oFbSStgk29JcKSwqlW1KDaQVtGq2CTeEl4JLgyWzUoOpQaqSrYFVwSXHkuDJZ9SoalBtKq1UFagptRS6ClsVKwqVC0prVQVqgq0lLoKWwUrOpODSbuUwaqCtVU2oJbBSuik4NFo6TBqkG1TNagVtBK5KToUWhoqWyUNUg'
  decompressData(base64Str)
}

// Base64转二进制
function base64ToBit(base64Str) {
  const base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  let bitStr = ''

  for (let i = 0; i < base64Str.length; i++) {
    const charCode = base64Chars.indexOf(base64Str[i])
    if (charCode === -1) break

    let binary = charCode.toString(2)
    while (binary.length < 6) {
      binary = '0' + binary
    }
    bitStr += binary
  }

  return bitStr
}

// 解压数据
function decompressData(base64Str) {
  const bitStr = base64ToBit(base64Str)
  let solarDate = { y: 1900, m: 1, d: 31, obj: new Date(1900, 0, 31, 0, 0, 0, 0) }
  let heavenlyStem = 6 // 天干
  let earthlyBranch = 0 // 地支

  for (let i = 0; i < bitStr.length;) {
    if (i + 16 >= bitStr.length) break

    const head = bitStr.substr(i, 4)
    i += 4

    const leapMonth = +`0b${head}`
    const monthCount = leapMonth > 0 ? 13 : 12
    const months = bitStr.substr(i, monthCount).split('').map(o => +o)
    i += monthCount

    table.push({
      solarDate,
      leapMonth,
      months,
      heavenlyStem,
      earthlyBranch
    })

    const dateCount = monthCount * 29 + months.filter(o => o === 1).length
    const newSolarDate = new Date(solarDate.obj.getTime() + dateCount * 24 * 60 * 60 * 1000)

    solarDate = {
      y: newSolarDate.getFullYear(),
      m: newSolarDate.getMonth() + 1,
      d: newSolarDate.getDate(),
      obj: newSolarDate
    }

    heavenlyStem = (heavenlyStem + 1) % 10
    earthlyBranch = (earthlyBranch + 1) % 12
  }
}

// 检查日期是否有效
function checkDate(year, month, date) {
  if (year < 1900 || year > 2100) {
    throw new Error('年份范围必须在1900-2100之间')
  }

  if (month < 1 || month > 12) {
    throw new Error('月份必须在1-12之间')
  }

  if (date < 1 || date > 31) {
    throw new Error('日期必须在1-31之间')
  }

  const testDate = new Date(year, month - 1, date)
  if (testDate.getFullYear() !== year || testDate.getMonth() + 1 !== month || testDate.getDate() !== date) {
    throw new Error('无效的日期')
  }
}

// 检查日期顺序
function isBefore(base, target) {
  if (base.y !== target.y) return base.y > target.y
  if (base.m !== target.m) return base.m > target.m
  return base.d > target.d
}

// 生成农历字符串
function getLunarStr(month, date, isLeap) {
  const monthStr = `${isLeap ? '闰' : ''}${lunarMonthStr[month - 1]}月`

  if (date <= 10) {
    return `${monthStr}初${numberStr[date - 1]}`
  } else if (date < 20) {
    return `${monthStr}十${numberStr[date - 11]}`
  } else if (date === 20) {
    return `${monthStr}廿十`
  } else if (date > 20 && date < 30) {
    return `${monthStr}廿${numberStr[date - 21]}`
  } else if (date === 30) {
    return `${monthStr}三十`
  } else {
    return `${monthStr}${date}`
  }
}

// 获取节气 (简化实现，仅返回null)
function getSolarTerm(year, month, date) {
  return null
}

// 获取农历信息
export function getLunar(year, month, date) {
  // 确保数据已初始化
  if (table.length === 0) {
    initLunarData()
  }

  year = Math.floor(+year)
  month = Math.floor(+month)
  date = Math.floor(+date)

  checkDate(year, month, date)

  let index = year - 1900
  let row = table[index]

  if (isBefore(row.solarDate, { y: year, m: month, d: date })) {
    index -= 1
    row = table[index]
  }

  if (!row) {
    throw new Error('无效的日期')
  }

  const targetDate = new Date(year, month - 1, date, 0, 0, 0, 0)
  let delta = Math.round((targetDate.getTime() - row.solarDate.obj.getTime()) / (24 * 60 * 60 * 1000))
  let afterLeap = false

  for (let i = 0; i < row.months.length; i++) {
    const isLeap = row.leapMonth > 0 && i === row.leapMonth

    if (isLeap) {
      afterLeap = true
    }

    const days = 29 + row.months[i]

    if (delta < days) {
      const lunarMonth = afterLeap ? i : i + 1

      return {
        lunarMonth,
        lunarDate: delta + 1,
        isLeap,
        solarTerm: getSolarTerm(year, month, date),
        lunarYear: `${heavenlyStemStr[row.heavenlyStem]}${earthlyBranchStr[row.earthlyBranch]}年`,
        zodiac: `${zodiacStr[row.earthlyBranch]}`,
        dateStr: getLunarStr(lunarMonth, delta + 1, isLeap)
      }
    } else {
      delta -= days
    }
  }

  throw new Error('获取农历信息失败')
}

// 初始化数据
initLunarData()
